import { IFetchListRequestPayload } from '@interfaces/common';
import {
  IImportMedicationsResponse,
  IImportSynonymsListResponse,
  IMedicationDetails,
  IMedicationSettings,
  IMedicationsSearchResult,
} from '@interfaces/medications';

import { apiUrls } from './urls';
import { get, post, upload } from './utils';

export const getMedicationSettings = () =>
  get<IMedicationSettings>(apiUrls.lookups.medicationSettings);

export const searchMedications = (payload: IFetchListRequestPayload) =>
  post<IMedicationsSearchResult>(apiUrls.medications.search, payload);

export const getMedicationDetails = (id: number) =>
  get<IMedicationDetails>(`${apiUrls.medications.details}/${id}`);

export const importCSVFile = (file: File) =>
  upload<IImportMedicationsResponse>(apiUrls.medications.importCSVFile, file);

export const importSynonymsListCSVFile = (file: File) =>
  upload<IImportSynonymsListResponse>(apiUrls.medications.importSynonymsListCSVFile, file);
